// Expose Vite's import.meta.env to libs/core via a global. libs/core can't
// reference `import.meta` directly because its CJS-compiled dist files would
// then be auto-detected as ESM by Node 22 and crash NestJS at boot.
(
	globalThis as { __VITE_ENV__?: Record<string, string | undefined> }
).__VITE_ENV__ = import.meta.env as unknown as Record<
	string,
	string | undefined
>;
(globalThis as { __VITE_HOT__?: unknown }).__VITE_HOT__ = import.meta.hot;

import { installNumberInputWheelGuard } from '@supply-mover-2-0/web-ui';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Capacitor iOS: tell the OS to overlay the status bar on top of the
// WebView so `env(safe-area-inset-top)` returns the actual status-bar /
// Dynamic Island height. Default Capacitor behavior positions the
// WebView BELOW the status bar, which collapses the inset to 0px — the
// header's `paddingTop: env(safe-area-inset-top)` then evaluates to 0
// and the search-bar row sits flush against the iOS chrome, reading as
// overlap on scroll. Setting overlay=true delegates layout responsibility
// to our CSS, which is what every other Capacitor storefront does.
//
// Side-effect at import time (not a useEffect) so the WebView shifts up
// before the first paint; deferring this to React mount time produces a
// brief visible reflow as the layout repositions. Wrapped in a
// Capacitor-native check so the dynamic import is tree-shaken out of the
// browser build entirely.
if (
	typeof window !== 'undefined' &&
	(
		window as { Capacitor?: { isNativePlatform?: () => boolean } }
	).Capacitor?.isNativePlatform?.() === true
) {
	void import('@capacitor/status-bar').then((statusBar) => {
		void statusBar.StatusBar.setOverlaysWebView({ overlay: true }).catch(
			() => {},
		);
		// The text style is NOT fixed here: BrandThemeApplier sets it from the
		// resolved header color for the current mode (PD-16079), so a dark
		// brand header gets white status text in light mode too.
	});
}

// PD-15480 — the scroll wheel must never enter a number (cart quantities
// included). See the CRM root for why this is installed globally.
installNumberInputWheelGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);

// Post-deploy self-heal (PD-15236): a lazy chunk that 404s because the tab's
// index.html predates the deploy gets one guarded reload instead of a dead
// "Loading..." screen. The guard clears after 30s of healthy runtime so the
// NEXT deploy can self-heal too.
const CHUNK_RELOAD_GUARD = 'workd:chunk-error:reloaded';
window.addEventListener('vite:preloadError', (event) => {
	try {
		if (sessionStorage.getItem(CHUNK_RELOAD_GUARD) != null) {
			return;
		}
		sessionStorage.setItem(CHUNK_RELOAD_GUARD, '1');
	} catch {
		// Storage unavailable — still better to try the reload once per load.
	}
	event.preventDefault();
	window.location.reload();
});
setTimeout(() => {
	try {
		sessionStorage.removeItem(CHUNK_RELOAD_GUARD);
	} catch {
		// Nothing to clear if storage is unavailable.
	}
}, 30_000);
